// import React from "react"
// import * as Yup from "yup";
// import { Formik, useFormik } from "formik";
// function CareerPage() {


//   const Formrik = useFormik({
//     initialValues: {
//       name: '',
//       gender: '',
//       location: '',
//       phone: '',
//       email: '',
//       linkedIn: '',
//       position_apply: '',
//       availability: '',
//       resume: '',
//       portfolio: '',
//       qualification: '',
//       year_graduate: '',
//       experience: '',
//       employer: '',
//       skills: '',
//       work_with_us: '',
//       salary_expectations: '',
//       current_salary: '',
//       refer_name: '',
//       refer_contact: '',
//       portfolio: '',
//       disability: '',
//     },
//     validationSchema: Yup.object({
//       name: Yup.string().required(('Name is required')),
//       phone: Yup.string().required(('phone number required')),
//       location: Yup.string().required(
//         'Enter Your location'
//       ),
//       gender: Yup.string(),
//       email: Yup.string()
//         .email('Must be a valid email')
//         .max(255)
//         .required(('Email is required')),
//       linked: Yup.string().required(),
//       position_apply: Yup.string(),
//       availability: Yup.string(),
//       resume: Yup.string(),
//       portfolio: Yup.string(),
//       qualification: Yup.string(),
//       year_graduate: Yup.string(),
//       experience: Yup.string(),
//       employer: Yup.string(),
//       skills: Yup.string(),
//       work_with_us: Yup.string(),
//       salary_expectations: Yup.string(),
//       current_salary: Yup.string(),
//       refer_name: Yup.string(),
//       refer_contact: Yup.string(),
//       portfolio: Yup.string(),
//       disability: Yup.string(),
//     }),
//     onSubmit: async (values, helpers) => {
//       try {
//         const body = {
//           ...values,
//           // idproof
//         }
//         // formSubmitHandler(body)
//       } catch (err) { }

//       console.log("Submit")
//     },
//   })
//   return (

//     <>


//       <div className=" mt-5 mb-5 container">

//         <div className="bd-form border">
//           <h4 className="text-center">Join Our Team</h4>


//           <form onSubmit={Formrik.handleSubmit}>
//             <div className="row ">


//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Full Name
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="fullname"
//                   placeholder="Full Name"
//                   {...Formrik.getFieldProps("name")}
//                 />
//                 {Formrik.touched.name &&
//                   Formrik.errors.name ? (
//                   <p className="text-danger m-0">
//                     {Formrik.errors.holder_name}
//                   </p>
//                 ) : null}
//               </div>



//               <div className="col-md-4 col-sm-6 col-12  form-group login-text">
//                 <label className="col-form-label">
//                   Gender
//                 </label>
//                 <select
//                   className="form-select"
//                   aria-label="gender"
//                   {...Formrik.getFieldProps("gender")}
//                 >
//                   <option value="" selected disabled>
//                     Select
//                   </option>
//                   <option value="male">Male</option>
//                   <option value="male">Female</option>
//                 </select>
//                 {Formrik.touched.gender &&
//                   Formrik.errors.gender ? (
//                   <p className="text-danger m-0">
//                     {Formik.errors.gender}
//                   </p>
//                 ) : null}
//               </div>


//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Email
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Email"
//                   {...Formrik.getFieldProps("email")}
//                 />
//                 {Formrik.touched.holder_name &&
//                   Formrik.errors.email ? (
//                   <p className="text-danger m-0">
//                     {Formrik.errors.email}
//                   </p>
//                 ) : null}
//               </div>



//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Phone
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Phone"
//                   {...Formrik.getFieldProps("Phone")}
//                 />
//                 {Formrik.touched.Phone &&
//                   Formrik.errors.Phone ? (
//                   <p className="text-danger m-0">
//                     {Formrik.errors.Phone}
//                   </p>
//                 ) : null}
//               </div>

//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   LinkedIn Profile(Use link)
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Account Holder Name"
//                   {...Formrik.getFieldProps("linkedIn")}
//                 />
//                 {Formrik.touched.linkedIn &&
//                   Formrik.errors.linkedIn ? (
//                   <p className="text-danger m-0">
//                     {Formrik.errors.linkedIn}
//                   </p>
//                 ) : null}
//               </div>


//               <div className="col-md-4 col-sm-6 col-12  form-group login-text">
//                 <label className="col-form-label">
//                   position_apply Applied For  *

//                 </label>
//                 <select
//                   className="form-select"
//                   aria-label="addbankname"
//                 // {...Formrik.getFieldProps("account_type")}
//                 >
//                   <option value="" selected disabled>
//                     Select
//                   </option>
//                   <option value="SSP">Selfie Sleeping Partner (SSP)</option>
//                   {/* <option value="Current">Female</option> */}
//                 </select>
//                 {/* {Formrik.touched.account_type &&
//                                           Formrik.errors.account_type ? (
//                                           <p className="text-danger m-0">
//                                             {Formik.errors.account_type}
//                                           </p>
//                                         ) : null} */}
//               </div>


//               <div className="col-md-4 col-sm-6 col-12  form-group login-text">
//                 <label className="col-form-label">
//                   Availability to Join
//                 </label>
//                 <select
//                   className="form-select"
//                   aria-label="addbankname"
//                   {...Formrik.getFieldProps("availabilty")}
//                 >
//                   <option value="" selected disabled>
//                     Select
//                   </option>
//                   <option value="immediate">Immediate</option>
//                   <option value="noticeperiod">Notice Period</option>
//                 </select>
//                 {Formrik.touched.availabilty &&
//                   Formrik.errors.availabilty ? (
//                   <p className="text-danger m-0">
//                     {Formik.errors.availabilty}
//                   </p>
//                 ) : null}
//               </div>


//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Location
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Location"
//                   {...Formrik.getFieldProps("location")}
//                 />
//                 {Formrik.touched.location &&
//                   Formrik.errors.location ? (
//                   <p className="text-danger m-0">
//                     {Formrik.errors.location}
//                   </p>
//                 ) : null}
//               </div>

//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Highest Qualification
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Highest Qualification"
//                 //   {...Formrik.getFieldProps("holder_name")}
//                 />
//                 {/* {Formrik.touched.holder_name &&
//                                       Formrik.errors.holder_name ? ( */}
//                 <p className="text-danger m-0">
//                   {/* {Formrik.errors.holder_name} */}
//                 </p>
//                 {/* ) : null} */}
//               </div>


//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Year of year_graduate
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Year of year_graduate"
//                 //   {...Formrik.getFieldProps("holder_name")}
//                 />
//                 {/* {Formrik.touched.holder_name &&
//                                       Formrik.errors.holder_name ? ( */}
//                 <p className="text-danger m-0">
//                   {/* {Formrik.errors.holder_name} */}
//                 </p>
//                 {/* ) : null} */}
//               </div>
//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Years of Relevant Experience
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Location"
//                 //   {...Formrik.getFieldProps("holder_name")}
//                 />
//                 {/* {Formrik.touched.holder_name &&
//                                       Formrik.errors.holder_name ? ( */}
//                 <p className="text-danger m-0">
//                   {/* {Formrik.errors.holder_name} */}
//                 </p>
//                 {/* ) : null} */}
//               </div>
//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Current/Last Employer
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Location"
//                 //   {...Formrik.getFieldProps("holder_name")}
//                 />
//                 {/* {Formrik.touched.holder_name &&
//                                       Formrik.errors.holder_name ? ( */}
//                 <p className="text-danger m-0">
//                   {/* {Formrik.errors.holder_name} */}
//                 </p>
//                 {/* ) : null} */}
//               </div>



//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Current Salary(Per Month)
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Current Salary"
//                 //   {...Formrik.getFieldProps("holder_name")}
//                 />
//                 {/* {Formrik.touched.holder_name &&
//                                       Formrik.errors.holder_name ? ( */}
//                 <p className="text-danger m-0">
//                   {/* {Formrik.errors.holder_name} */}
//                 </p>
//                 {/* ) : null} */}
//               </div>
//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Salary Expectations
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder="Salary Expectations"
//                 //   {...Formrik.getFieldProps("holder_name")}
//                 />
//                 {/* {Formrik.touched.holder_name &&
//                                       Formrik.errors.holder_name ? ( */}
//                 <p className="text-danger m-0">
//                   {/* {Formrik.errors.holder_name} */}
//                 </p>
//                 {/* ) : null} */}
//               </div>
//               <div className="col-md-4 col-sm-6 col-12   form-group login-text">
//                 <label className="col-form-label">
//                   Reference Name
//                 </label>
//                 <span className="text-danger">*</span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name"
//                   placeholder=" Reference Name"
//                 //   {...Formrik.getFieldProps("holder_name")}
//                 />
//                 {/* {Formrik.touched.holder_name &&
//                                       Formrik.errors.holder_name ? ( */}
//                 <p className="text-danger m-0">
//                   {/* {Formrik.errors.holder_name} */}
//                 </p>
//                 {/* ) : null} */}
//               </div>



//               <div className="col-md-4 col-sm-6 col-12  form-group login-text">
//                 <label className="col-form-label">Refernce Contact</label>

//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name3"
//                   placeholder="Refernce Contact"
//                 // {...Formrik.getFieldProps("ifsc")}
//                 />
//                 {/* {Formrik.touched.ifsc && Formrik.errors.ifsc ? (
//                                           <p className="text-danger m-0">
//                                             {Formrik.errors.ifsc}
//                                           </p>
//                                         ) : null} */}
//               </div>




//               <div className="col-md-4 col-sm-6 col-12  form-group login-text">
//                 <label className="col-form-label">Portfolio/Work Samples (use link)</label>

//                 <input
//                   type="text"
//                   className="form-control"
//                   id="recipient-name3"
//                   placeholder="Portfolio/Work Samples"
//                 // {...Formrik.getFieldProps("ifsc")}
//                 />
//                 {/* {Formrik.touched.ifsc && Formrik.errors.ifsc ? (
//                                           <p className="text-danger m-0">
//                                             {Formrik.errors.ifsc}
//                                           </p>
//                                         ) : null} */}
//               </div>


//               <div className="col-md-4 col-sm-6 col-12  form-group login-text">
//                 <label className="col-form-label">
//                   Are You a person with a disability?
//                 </label>
//                 <select
//                   className="form-select"
//                   aria-label="addbankname"
//                 // {...Formrik.getFieldProps("account_type")}
//                 >
//                   <option value="" selected disabled>
//                     Select
//                   </option>
//                   <option value="yes">Yes</option>
//                   <option value="no">No</option>
//                 </select>
//                 {/* {Formrik.touched.account_type &&
//                                           Formrik.errors.account_type ? (
//                                           <p className="text-danger m-0">
//                                             {Formik.errors.account_type}
//                                           </p>
//                                         ) : null} */}
//               </div>












//               <div className="col-md-6 col-12">
//                 <div className="form-group submit login-text">
//                   <label>
//                     Key Skills
//                   </label>
//                   <textarea
//                     className="form-control"
//                     id="exampleFormControlTextarea1"
//                     rows={5}

//                   // {...Formik2.getFieldProps("requirement")}
//                   ></textarea>
//                   {/* {Formik2.touched.requirement && Formik2.errors.requirement ? (
//                     <p className="text-danger">{Formik2.errors.requirement}</p>
//                   ) : null} */}
//                 </div>
//               </div>


//               <div className="col-md-6 col-12">
//                 <div className="form-group submit login-text">
//                   <label>
//                     Why Do You Want to Work With Us?
//                   </label>
//                   <textarea
//                     className="form-control"
//                     id="exampleFormControlTextarea1"
//                     rows={5}

//                   // {...Formik2.getFieldProps("requirement")}
//                   ></textarea>
//                   {/* {Formik2.touched.requirement && Formik2.errors.requirement ? (
//                     <p className="text-danger">{Formik2.errors.requirement}</p>
//                   ) : null} */}
//                 </div>
//               </div>

//             </div>


//             <div className="">
//               <input className="form-check-input" type="checkbox" value="" id="agreecheck" />

//               <label className="form-check-label ms-2" htmlFor="flexCheckDefault">
//                 I certify that the information provided is true and accurate.
//                 *
//               </label>
//             </div>

//             <div className="mb-3">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 value=""
//                 id="agreecheck"
//               // onChange={(e) => {
//               //   setchecked(e.target.checked);
//               // }}
//               />

//               <label
//                 className="form-check-label ms-2"
//                 htmlFor="flexCheckDefault"
//               >
//                 I certify that the information provided is true and accurate.
//                 *
//               </label>


//             </div>



//             <button className="text-white" type="submit">
//               none
//               {/* <span
//               className="spinner-border spinner-border-sm"
//               role="status"
//             ></span> */}

//             </button>
//           </form>


//         </div>
//       </div>
//     </>




//   )
// }

// export default CareerPage;
import React from "react"
import * as Yup from "yup";
import { useRef, useState } from "react";
import { useFormik } from "formik";
import { career_fun } from "../api/Dashboardapi";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function CareerPage() {

  const navigate = useNavigate()

  const formik = useFormik({
    initialValues: {
      name: '',
      gender: '',
      location: '',
      phone: '',
      email: '',
      linkedin: '',
      whatsapp: '',
      instagram: '',
      facebook: '',
      position_apply: '',
      availability: '',
      resume: '',
      portfolio: '',
      qualification: '',
      year_graduate: '',
      experience: '',
      current_employer: '',
      skills: '',
      work_with_us: '',
      salary_expectations: '',
      current_salary: '',
      refer_name: '',
      refer_contact: '',
      disability: '',
    },
    validationSchema: Yup.object({
      name: Yup.string()
        // .required("Name is required")
        .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed"),
      // .test(
      //   "not-only-spaces",
      //   "Name cannot be only spaces",
      //   (value) => value && value.trim().length > 0),



      phone: Yup.string().
        required('Phone number required'),
      location: Yup.string(),
      gender: Yup.string(),
      email: Yup.string()
        .email('Must be a valid email')
        .max(255),
      linkedin: Yup.string(),
      whatsapp: Yup.string(),
      instagram: Yup.string(),
      facebook: Yup.string(),
      current_employer: Yup.string(),
      position_apply: Yup.string(),
      availability: Yup.string(),
      qualification: Yup.string(),
      year_graduate: Yup.string(),
      experience: Yup.string(),
      // resume: Yup.array()
      // .min(1, 'resume is required')
      // .test('fileSize', 'File size too large (max 5MB)', (value) => {
      //   if (!value || value.length === 0) return true;
      //   return value.every(file => file.size <= 5 * 1024 * 1024);
      // })
      // .test('fileType', 'Only PDF, DOC, DOCX files are allowed', (value) => {
      //   if (!value || value.length === 0) return true;
      //   return value.every(file => 
      //     ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)
      //   );

      //   }),
      resume: Yup.mixed()
        .required('resume is required')
        .test('fileSize', 'File size too large (max 5MB)', (file) => {
          if (!file) return true;
          return file.size <= 5 * 1024 * 1024; // 5MB
        })
        .test('fileType', 'Only PDF, DOC, DOCX files are allowed', (file) => {
          if (!file) return true;
          return ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type);
        }),




      skills: Yup.string(),
      work_with_us: Yup.string(),
      salary_expectations: Yup.string(),
      current_salary: Yup.string(),
      refer_name: Yup.string(),
      refer_contact: Yup.string(),
      portfolio: Yup.string(),
      disability: Yup.string(),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const formData = new FormData();

        // Append all other form fields
        for (const key in values) {
          if (key !== 'resume') {
            formData.append(key, values[key] || '');
          }
        }
        if (values.resume) {
          formData.append('resume', values.resume);
        }
        // console.log(' FormData contents:');
        for (let [key, value] of formData.entries()) {
          // console.log(`${key}:`, value);
        }

        // Uncomment to send to API

        // const response = await fetch('https://greenheapgold.com/career', {
        //   method: 'POST',
        //   body: formData,
        // });
        career_fun(formData)
          .then((res) => {
            // setspinner(false);
            // toast.success(res?.message);
            // handlegetprofile();
            toast.success("Submited Successfully")
            // console.log("suceess");
            // console.log(res)
            navigate('/')
            helpers.resetForm();
          })
          .catch((err) => {
            console.error("Submission error:", err);
            const errorData = err?.response?.data;
            if (errorData && typeof errorData === 'object') {
              for (const key in errorData) {
                if (Array.isArray(errorData[key])) {
                  errorData[key].forEach((msg) => {
                    toast.error(msg);
                  });
                }
              }
            } else {
              toast.error(err.message || "Something went wrong");
            }
          });

        // const response = career_fun()

        // if (!response.ok) {
        //   throw new Error(`Failed to submit: ${response.status}`);
        // }

        // const result = await response.json();
        // console.log(' Submission Success:', result);
        // helpers.resetForm();


      } catch (err) {
        console.error(" Submission error:", err);
      }
    }
  });




  const fileInputRef = useRef();
  const [fileNames, setFileNames] = useState([]);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleAadhar = (e) => {
    const files = Array.from(e.target.files);
    setFileNames(files.map(file => file.name)); //  Set file names in state

    // If you're using Formik to manage the file input:
    formik.setFieldValue("resume", files); // or a single file if not multiple
  };

  return (
    <div className="mt-5 mb-5 container">
      <div className="bd-form border">
        <h4 className="text-center">Join Our Team</h4>

        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            {/* Full Name */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Full Name</label>

              <input
                type="text"
                className="form-control"
                placeholder="Full Name"
                {...formik.getFieldProps("name")}
              />
              {formik.touched.name && formik.errors.name ? (
                <p className="text-danger m-0">{formik.errors.name}</p>
              ) : null}
            </div>

            {/* Gender */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Gender</label>

              <select
                className="form-select"
                {...formik.getFieldProps("gender")}
              >
                <option value="" disabled>Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              {formik.touched.gender && formik.errors.gender ? (
                <p className="text-danger m-0">{formik.errors.gender}</p>
              ) : null}
            </div>

            {/* Email */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Email</label>

              <input
                type="email"
                className="form-control"
                placeholder="Email"
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <p className="text-danger m-0">{formik.errors.email}</p>
              ) : null}
            </div>

            {/* Phone */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Phone</label>
              <span className="text-danger"> *</span>
              <input
                type="number"
                className="form-control"
                placeholder="Phone"
                {...formik.getFieldProps("phone")}
              />
              {formik.touched.phone && formik.errors.phone ? (
                <p className="text-danger m-0">{formik.errors.phone}</p>
              ) : null}
            </div>

            {/* LinkedIn Profile */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">LinkedIn Profile (Use link)</label>

              <input
                type="text"
                className="form-control"
                placeholder="LinkedIn Profile"
                {...formik.getFieldProps("linkedin")}
              />
              {formik.touched.linkedIn && formik.errors.linkedin ? (
                <p className="text-danger m-0">{formik.errors.linkedin}</p>
              ) : null}
            </div>

            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">WhatsApp Number</label>

              <input
                type="number"
                className="form-control"
                placeholder="Whatsapp Number"
                {...formik.getFieldProps("whatsapp")}
              />
              {formik.touched.whatsapp && formik.errors.whatsapp ? (
                <p className="text-danger m-0">{formik.errors.whatsapp}</p>
              ) : null}
            </div>

            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">FaceBook(Use link)</label>

              <input
                type="text"
                className="form-control"
                placeholder="FaceBook Profile"
                {...formik.getFieldProps("facebook")}
              />
              {formik.touched.linkedIn && formik.errors.facebook ? (
                <p className="text-danger m-0">{formik.errors.facebook}</p>
              ) : null}
            </div>

            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Instagram(Use link)</label>

              <input
                type="text"
                className="form-control"
                placeholder="Instagram Profile"
                {...formik.getFieldProps("instagram")}
              />
              {formik.touched.linkedIn && formik.errors.instagram ? (
                <p className="text-danger m-0">{formik.errors.instagram}</p>
              ) : null}
            </div>

            {/* position_apply Applied For */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Position Applied For </label>

              {/* <select
                className="form-select"
                {...formik.getFieldProps("position_apply")}
              >
                <option value="" disabled>Select</option>
                <option value="SSP">Selfie Sleeping Partner (SSP)</option>
              </select> */}
              <input
                type="text"
                className="form-control"
                placeholder="Position Apply for"
                {...formik.getFieldProps("position_apply")}
              />
              {formik.touched.position_apply && formik.errors.position_apply ? (
                <p className="text-danger m-0">{formik.errors.position_apply}</p>
              ) : null}
            </div>

            {/* Availability to Join */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Availability to Join</label>

              <select
                className="form-select"
                {...formik.getFieldProps("availability")}
              >
                <option value="" disabled>Select</option>
                <option value="immediate">Immediate</option>
                <option value="noticeperiod">Notice Period</option>
              </select>
              {formik.touched.availability && formik.errors.availability ? (
                <p className="text-danger m-0">{formik.errors.availability}</p>
              ) : null}
            </div>

            {/* location */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Location</label>

              <input
                type="text"
                className="form-control"
                placeholder="location"
                {...formik.getFieldProps("location")}
              />
              {formik.touched.location && formik.errors.location ? (
                <p className="text-danger m-0">{formik.errors.location}</p>
              ) : null}
            </div>

            {/* Highest Qualification */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Highest Qualification</label>

              <input
                type="text"
                className="form-control"
                placeholder="Highest Qualification"
                {...formik.getFieldProps("qualification")}
              />
            </div>

            {/* Year of year_graduate */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Year of Graduation</label>
              <input
                type="number"
                className="form-control"
                placeholder="Year of Graduation"
                {...formik.getFieldProps("year_graduate")}
              />
            </div>

            {/* Years of Relevant Experience */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Years of Relevant Experience</label>
              <input
                type="number"
                className="form-control"
                placeholder="Years of Experience"
                {...formik.getFieldProps("experience")}
              />
            </div>

            {/* Current/Last Employer */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Current/Last Employer</label>
              {/* <span className="text-danger"> *</span> */}
              <input
                type="text"
                className="form-control"
                placeholder="Employer"
                {...formik.getFieldProps("current_employer")}
              />
            </div>

            {/* Current Salary */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Current Salary (Per Month)</label>

              <input
                type="number"
                className="form-control"
                placeholder="Current Salary"
                {...formik.getFieldProps("current_salary")}
              />
            </div>

            {/* Salary Expectations */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Salary Expectations</label>
              <input
                type="number"
                className="form-control"
                placeholder="Salary Expectations"
                {...formik.getFieldProps("salary_expectations")}
              />
            </div>





            {/* Reference Name */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Reference Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Reference Name"
                {...formik.getFieldProps("refer_name")}
              />
            </div>

            {/* Reference Contact */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Reference Contact</label>
              <input
                type="text"
                className="form-control"
                placeholder="Reference Contact"
                {...formik.getFieldProps("refer_contact")}
              />
            </div>

            {/* Portfolio/Work Samples */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Portfolio/Work Samples (use link)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Portfolio/Work Samples"
                {...formik.getFieldProps("portfolio")}
              />
            </div>

            {/* Disability */}
            <div className="col-md-4 col-sm-6 col-12 form-group login-text">
              <label className="col-form-label">Are You a person with a disability?</label>
              <select
                className="form-select"
                {...formik.getFieldProps("disability")}
              >
                <option value="" disabled>Select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>

            {/* Key Skills */}
            <div className="col-md-6 col-12">
              <div className="form-group submit login-text">
                <label>Key Skills</label>
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Key Skills"
                  {...formik.getFieldProps("skills")}
                ></textarea>
              </div>
            </div>

            {/* Why Work With Us */}
            <div className="col-md-6 col-12">
              <div className="form-group submit login-text">
                <label>Why Do You Want to Work With Us?</label>
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Why do you want to work with us?"
                  {...formik.getFieldProps("work_with_us")}
                ></textarea>
              </div>
            </div>
              
            <div className="form-group mb-3 col-md-6 col-12 login-text">
              <label>
                Upload Resume Documents{" "}
                <span className="text-danger doc-format"> *(PDF, DOC)</span>
              </label>

              <div className="upload-docs">
                <button className="btn" type="button" onClick={handleButtonClick}>
                  <span>
                    <img src="\assets\iocns\upload.png" alt="upload" />
                  </span>{" "}
                  Image Upload
                </button>
              </div>

              <input
                className="form-control d-none"
                ref={fileInputRef}
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setFileNames(file ? [file.name] : []);
                  formik.setFieldValue("resume", file);
                }}
              />

              {/* {fileNames.length > 0 && (
                <ul className="mt-2">
                  {fileNames.map((name, index) => (
                    <li
                      key={index}
                      style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '300px' // adjust as needed
                      }}
                      title={name} // optional: show full name on hover
                    >
                      {name}
                    </li>
                  ))}
                </ul>
              )} */}


              {fileNames.length > 0 && (
                <ul className="mt-2">
                  {fileNames.map((name, index) => (
                    <li key={index} style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '300px' // adjust as needed
                    }}>{name}</li>
                  ))}
                </ul>
              )}

              {/* Formik error display */}
              {formik.touched.resume && formik.errors.resume && (
                <p className="text-danger m-0">{formik.errors.resume}</p>
              )}
            </div>






          </div>

          {/* Agreement Checkbox */}
          <div className="mb-3 d-flex align-items-center">
            <input
              className="form-check-input"
              type="checkbox"
              id="agreecheck"
              required
            />
            <label className="form-check-label ms-2" htmlFor="agreecheck">
              I certify that the information provided is true and accurate. <span className="text-danger"> *</span>
            </label>
          </div>

          {/* Submit Button */}
          <div className="myac-submit submit mt-sm-5 mt-3">
            <button className="text-white" type="submit">

              Submit

            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CareerPage;